<template>
  <div class="map-container">
    <div
      v-for="area in mapAreas"
      :key="area.name"
      :ref="`area-${area.name}`"
      class="map-area"
      :class="{ 'is-active': selectedArea === area.name }"
      :style="{ left: area.left, top: area.top }"
      @click="handleAreaClick(area)"
    >
      <img :src="getAreaImage(area)" :alt="area.name" />
      <span class="area-name" :style="area.name == '武胜关' ? 'left:60%;top:51%' : ''">{{
        area.name
      }}</span>
    </div>
    <div
      v-if="selectedAreaData && selectedAreaData.popupImage"
      class="popup-image"
      :style="popupStyle"
    >
      <img :src="selectedAreaData.popupImage" :alt="selectedArea + ' 悬浮框'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data() {
    return {
      selectedArea: null,
      mapAreas: [
        {
          name: '武胜关',
          areaCode: 'wsg',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/武胜关@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/武胜关@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/武胜关@2x(2).png',
          left: '992px',
          top: '308px',
          popupOffset: { x: 180, y: 120 },
        },
        {
          name: '杨寨',
          areaCode: 'yz',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/杨寨@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/杨寨@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/杨寨@2x(2).png',
          left: '999px',
          top: '699px',
          popupOffset: { x: 160, y: 120 },
        },
        {
          name: '太平',
          areaCode: 'tp',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/太平@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/太平@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/太平@2x(2).png',
          left: '848px',
          top: '830px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '长岭',
          areaCode: 'cl',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/长岭@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/长岭@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/长岭@2x(2).png',
          left: '443px',
          top: '549px',
          popupOffset: { x: -180, y: 300 },
        },
        {
          name: '余店',
          areaCode: 'yd',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/余店@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/余店@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/余店@2x(2).png',
          left: '395px',
          top: '165px',
          popupOffset: { x: -120, y: 110 },
        },
        {
          name: '关庙',
          areaCode: 'gm',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/关庙@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/关庙@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/关庙@2x(2).png',
          left: '518px',
          top: '350px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '吴店',
          areaCode: 'wd',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/吴店@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/吴店@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/吴店@2x(2).png',
          left: '509px',
          top: '-150px',
          popupOffset: { x: -220, y: 320 },
        },
        {
          name: '马坪',
          areaCode: 'mp',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/马坪@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/马坪@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/马坪@2x(2).png',
          left: '406px',
          top: '508px',
          popupOffset: { x: -180, y: 110 },
        },
        {
          name: '蔡河',
          areaCode: 'ch',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/蔡河@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/蔡河@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/蔡河@2x(2).png',
          left: '736px',
          top: '190px',
          popupOffset: { x: 220, y: 60 },
        },
        {
          name: '郝店',
          areaCode: 'hd',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/郝店@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/郝店@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/郝店@2x(2).png',
          left: '603px',
          top: '22px',
          popupOffset: { x: 160, y: 120 },
        },
        {
          name: '广水',
          areaCode: 'gs',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/广水@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/广水@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/广水@2x(2).png',
          left: '917px',
          top: '464px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '城郊',
          areaCode: 'cj',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/城郊@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/城郊@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/城郊@2x(2).png',
          left: '605px',
          top: '522px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '骆店',
          areaCode: 'ld',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/骆店@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/骆店@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/骆店@2x(2).png',
          left: '623px',
          top: '673px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '十里',
          areaCode: 'sl',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/十里@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/十里@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/十里@2x(2).png',
          left: '817px',
          top: '388px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '应山',
          areaCode: 'ys',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/应山@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/应山@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/应山@2x(2).png',
          left: '788px',
          top: '566px',
          popupOffset: { x: 80, y: 0 },
        },
        {
          name: '开发区',
          areaCode: 'kfq',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/开发区@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/开发区@2x(1).png',
          left: '1074px',
          top: '609px',
        },
        {
          name: '陈巷',
          areaCode: 'cx',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/陈巷@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/陈巷@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/陈巷@2x(2).png',
          left: '574px',
          top: '761px',
          popupOffset: { x: 80, y: 220 },
        },
        {
          name: '李店',
          areaCode: 'lid',
          image:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/李店@2x.png',
          activeImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/李店@2x(1).png',
          popupImage:
            'https://gs-erp-1329649789.cos.ap-shanghai.myqcloud.com/gs/file/新大屏地图/李店@2x(2).png',
          left: '862px',
          top: '656px',
          popupOffset: { x: 80, y: 0 },
        },
      ],
    }
  },
  computed: {
    selectedAreaData() {
      return this.mapAreas.find(item => item.name === this.selectedArea)
    },
    popupStyle() {
      if (!this.selectedAreaData) return {}
      const leftValue = parseInt(this.selectedAreaData.left)
      const topValue = parseInt(this.selectedAreaData.top)
      const offset = this.selectedAreaData.popupOffset || { x: 80, y: 0 }
      return {
        left: `${leftValue + offset.x}px`,
        top: `${topValue + offset.y}px`,
      }
    },
  },
  methods: {
    getAreaImage(area) {
      return this.selectedArea === area.name ? area.image : area.activeImage
    },
    handleAreaClick(area) {
      this.selectedArea = area.name
      this.$emit('area-click', area)
    },
    // 外部调用设置选中区域
    setSelectedArea(areaCode) {
      const area = this.mapAreas.find(item => item.areaCode === areaCode)
      if (area) {
        this.selectedArea = area.name
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.map-container {
  position: relative;
  z-index: 7777;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;

  .map-area {
    z-index: 1;
    position: absolute;
    cursor: pointer;
    transition: all 0.15s ease;

    img {
      display: block;
      transition: transform 0.15s ease, filter 0.15s ease;
    }

    &.is-active {
      img {
        filter: drop-shadow(0 0 8px rgba(64, 169, 255, 0.8))
          drop-shadow(0 0 16px rgba(64, 169, 255, 0.6))
          drop-shadow(0 0 24px rgba(64, 169, 255, 0.4));
      }
    }

    .area-name {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 26px;
      color: #fff;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
      white-space: nowrap;
      z-index: 10;
    }
  }

  .popup-image {
    z-index: 9999;
    position: absolute;
    transform: translateY(-50%);
    pointer-events: none;

    img {
      display: block;
      max-width: 200px;
      height: auto;
    }
  }
}
</style>
